var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitInputData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 30.5L24.5 24.5L18.5 18.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24.5H24.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 13.6046V35.3954C30.5 36.0055 30.9945 36.5 31.6046 36.5H35.3954C36.0055 36.5 36.5 36.0055 36.5 35.3954V13.6046C36.5 12.9945 36.0055 12.5 35.3954 12.5H31.6046C30.9945 12.5 30.5 12.9945 30.5 13.6046Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.9182L6.5 38.0818C6.5 40.5219 8.47811 42.5 10.9182 42.5H38.0818C40.5219 42.5 42.5 40.5219 42.5 38.0818V10.9182C42.5 8.47811 40.5219 6.5 38.0818 6.5H10.9182C8.47811 6.5 6.5 8.47811 6.5 10.9182Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitInputData);
export default __webpack_public_path__ + "static/media/submitInputData.9c16d85a6a6339c6638a7a0993222509.svg";
export { ForwardRef as ReactComponent };